import { isFunction } from 'gleam-shared/helpers/nodash'
import toSeconds from 'gleam-shared/helpers/toSeconds'

export default function Watchdog(delay, resource, input) {
  if (!input) {
    input = resource
    resource = 'The resource'
  }

  if (isFunction(input)) {
    return WatchdogTimeout(delay, resource, input)
  } else {
    return WatchdogWrapper(delay, resource, input)
  }
}

function WatchdogWrapper(delay, resource, promise) {
  return new Promise((resolve, reject) => {
    const watchdog = WatchdogTimeout(delay, resource, reject)
    promise.finally(watchdog.destroy).then(resolve, reject)
  })
}

function WatchdogTimeout(delay, resource, callback) {
  let destroyed = false
  let timeoutId = null

  if (!(delay > 0)) {
    throw new Error('WatchdogTimeout: negative delay does not make sense!')
  }

  if (isVisible()) {
    timeoutId = setTimeout(onTimeout, delay)
  }

  document.addEventListener('visibilitychange', onVisibilityChange)

  return { destroy }

  function destroy() {
    destroyed = true
    clearTimeout(timeoutId)
    document.removeEventListener('visibilitychange', onVisibilityChange)
  }

  function onTimeout() {
    if (destroyed) {
      return
    }

    destroy()
    callback(new Error(`${resource} didn't load in ${toSeconds(delay)}!`))
  }

  function onVisibilityChange() {
    if (destroyed) {
      return
    }

    if (isVisible()) {
      timeoutId = setTimeout(onTimeout, delay)
    } else {
      clearTimeout(timeoutId)
    }
  }

  function isVisible() {
    return document.visibilityState === 'visible'
  }
}
